import "./NewComment.css";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import React, { useRef, useState } from "react";
import { flushSync } from "react-dom";
import Paper from "@mui/material/Paper";
import { useSetRecoilState } from "recoil";
import { UploadedFile } from "@shared/mirage/core/contracts/UploadedFile";
import { commentFiles } from "@publicPortal/pages/planningApplication/tabContent/components/NewCommentAttachments";
import { CircularProgress } from "@mui/material";

const NewComment: React.FC<INewComment> = ({ ...props }) => {
    const [open, setOpen] = useState(false);
    const [commentSaveLoading, setCommentSaveLoading] = useState(false);
    const setFiles = useSetRecoilState<UploadedFile[]>(commentFiles);
    const handleClose = () => {
        setFiles([]);
        setOpen(false);
    };
    const handleOpen = () => setOpen(true);
    const newCommentRef = useRef<HTMLElement>();

    const handleAddComment = () => {
        flushSync(() => {
            handleOpen();
        });
        if (newCommentRef.current) {
            newCommentRef.current.scrollIntoView({
                block: "center",
                inline: "nearest",
                behavior: "smooth",
            });
        }
    };

    if (!open) {
        return (
            <Button className="newCommentButton" variant="contained" onClick={handleAddComment}>
                Add Comment
            </Button>
        );
    } else {
        return (
            <>
                <Fade in={open} unmountOnExit ref={newCommentRef}>
                    <Paper elevation={12} className="newCommentFormContainer">
                        <form className="newCommentFormContainer__form">
                            {props.children}
                            <div className="newCommentFormContainer__form__buttonsContainer">
                                <Button variant="contained" onClick={handleSaveComment} startIcon={getLoadingIcon()} disabled={commentSaveLoading}>
                                    Save
                                </Button>
                                <Button variant="outlined" type="reset" onClick={handleClose} disabled={commentSaveLoading}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </Paper>
                </Fade>
            </>
        );
    }

    function getLoadingIcon() {
        if (commentSaveLoading) {
            return <CircularProgress className="newCommentFormContainer__form__buttonsContainer__icon--progress" />;
        }
        return null;
    }

    async function handleSaveComment() {
        setCommentSaveLoading(true);
        const keepOpen = await props.handleSave();
        setCommentSaveLoading(false);
        setOpen(keepOpen);
        !keepOpen && setFiles([]);
    }
};

interface INewComment {
    children: JSX.Element | JSX.Element[];
    handleSave: () => Promise<boolean>;
}

export default NewComment;
